export default __webpack_public_path__ + "static/media/wiki.f68668ea.svg";